export const getTokenHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token") || ''}`,
});

export const getImageTokenHeaders = () => ({
  "Content-Type": "multipart/form-data",
  Authorization: `Bearer ${localStorage.getItem("token") || ''}`,
});
